import Link from '@/components/common/link/Link';
import { getSocialMediaLabel } from '@/utils/talent';

type FollowOnSocialMediaProps = {
  firstName: string;
  links: (string | null | undefined)[];
};

const FollowOnSocialMedia = ({
  firstName,
  links,
}: FollowOnSocialMediaProps) => {
  if (links.length === 0) {
    return;
  }

  return (
    <div data-testid='follow-on-social-media'>
      {links.length === 1 && (
        <>
          Follow {`${firstName} on`}{' '}
          <Link key={links[0]} next={false} href={links[0] ?? ''}>
            {getSocialMediaLabel(links[0] ?? '')}
          </Link>
          .
        </>
      )}
      {links.length === 2 && (
        <>
          Follow {`${firstName} on`}{' '}
          <Link key={links[0]} next={false} href={links[0] ?? ''}>
            {getSocialMediaLabel(links[0] ?? '')}
          </Link>
          {' and '}
          <Link key={links[1]} next={false} href={links[1] ?? ''}>
            {getSocialMediaLabel(links[1] ?? '')}
          </Link>
          .
        </>
      )}
      {links.length > 2 && (
        <>
          Follow {`${firstName} on`}{' '}
          {links.map((link, index) => {
            // if last link, prefix 'and'
            if (index === links.length - 1) {
              return (
                <Link key={link} next={false} href={link ?? ''}>
                  {`and ${getSocialMediaLabel(link ?? '')}.`}
                </Link>
              );
            }

            return (
              <Link key={link} next={false} href={link ?? ''}>
                {`${getSocialMediaLabel(link ?? '')}, `}
              </Link>
            );
          })}
        </>
      )}
    </div>
  );
};

export default FollowOnSocialMedia;
